module.exports = __webpack_public_path__ + "static/media/logo.png.68e58f55.zip";